import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ISearchable } from 'src/app/common/contracts/components/searchable';
import { DoctorDto } from 'src/app/shared/models/institution/doctor-dto.model';

import { IListView } from '../../../contracts/list-view';

@Component({
  selector: 'doctor-list-item',
  templateUrl: 'doctor-list-item.html',
  styleUrls: ['./../autocomplete-list-item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoctorListItem implements IListView {
  @Input() item: DoctorDto;
  @Output() clicked: EventEmitter<ISearchable> = new EventEmitter<ISearchable>();

  triggerEvent() {
    this.clicked.emit(this.item);
  }
}
